<template>
  <div class="header">
    <h2 class="header__title">
      {{ title }}
    </h2>
    <div class="header__actions">
      <ReviewsCategoriesDatePicker @change="$emit('date-change', $event)" />
      <slot />
    </div>
  </div>
</template>

<script>
import ReviewsCategoriesDatePicker from "@/components/Reviews/Categories/ReviewsCategoriesDatePicker.vue";

export default {
  name: "ReviewsCategoriesHeader",
  components: {
    ReviewsCategoriesDatePicker
  },
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  margin: $spacing * 1.5 0 $spacing * 5 0;

  &__title {
    @include font-size(30px);
  }
  &__actions {
    display: flex;
    flex-grow: 1;
    align-items: center;
    padding-left: $spacing * 2;
    justify-content: flex-end;
  }
}
</style>
